const DoubleValueSetter = (params, { allowDash = false } = {}) => {
    const val = String(params.newValue ?? '').trim();
    if (allowDash && val === '-') { params.data[params.colDef.field] = '-'; return true; }
    const num = parseFloat(val);
    if (isNaN(num)) return false;
    params.data[params.colDef.field] = val;
    return true;
};

export default DoubleValueSetter;
